export default __webpack_public_path__ + "static/media/detailsCarComplete.2a6177e6.png";